import type { SubAppSetting } from "@spiral-app/core";
import { getEnvArea } from "./utils";

/**
 * 子应用枚举
 */
export const enum SUB_APP_NAME {
  EP = "ep-app",
  ENERGY = "energy-app",
}

const config = {
  [SUB_APP_NAME.EP]: {
    dev_cn: "//equipment-portal-web.dev.starcharge.cloud",
    test_cn: "//equipment-portal-web.test.starcharge.cloud",
    test_sg: "//equipment-portal-web.oversea-test.starcharge.cloud",
    prod_cn: "//equipment-portal-cn.starcharge.com",
    prod_eu: "//equipment-portal-sg.starcharge.com",
    prod_us: "//equipment-portal-us.starcharge.com",
    prod_sg: "//equipment-portal-sg.starcharge.com",
    uat_sg: "//uat-quipment-admin-web.starcharge.com",
  },
  [SUB_APP_NAME.ENERGY]: {
    dev_cn: "//smart-energy-web.dev.starcharge.cloud",
    test_cn: "//smart-energy-web.test.starcharge.cloud",
    test_sg: "//smart-energy-web.oversea-test.starcharge.cloud",
    prod_cn: "//sc-energy.starcharge.com",
    prod_eu: "//sc-energy-eu.starcharge.com",
    prod_sg: "//sc-energy-sg.starcharge.com",
  },
};

const getSubApps = () => {
  const envArea = getEnvArea();
  const subApps: SubAppSetting[] = Object.entries(config).map(([key, value]) => {
    return {
      url: Number(process.env.EP) ? "http://localhost:3927" : value[envArea as keyof typeof value],
      name: key,
      baseRoute: `/${key}`,
      compatible: key === SUB_APP_NAME.EP ? "memory" : "pure",
    };
  });
  return subApps;
};

/**
 * 子应用配置
 */
const subApps = getSubApps();

export default subApps;
